import { render } from "./ConsultarOrcamento.vue?vue&type=template&id=572b59d4&scoped=true"
import script from "./ConsultarOrcamento.vue?vue&type=script&lang=js"
export * from "./ConsultarOrcamento.vue?vue&type=script&lang=js"

import "./ConsultarOrcamento.vue?vue&type=style&index=0&id=572b59d4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572b59d4"]])

export default __exports__